import Jobs from './Jobs';
import { usePageLoadTracking } from '../../../hooks/usePerformanceTracking';
import { useSetPageMeta } from '../../../hooks/usePageMeta';

/**
 * JobsPage - Page wrapper for the Jobs list view
 * 
 * All necessary providers (Customer, Services, Business, Jobs, Employees, Invoices)
 * are provided at the route level in App.tsx
 */
export default function JobsPage() {
  usePageLoadTracking('jobs-page');
  
  // Set page metadata
  useSetPageMeta({
    title: 'Jobs',
    description: 'Manage scheduled and completed jobs'
  });
  
  return <Jobs />;
}